import { Sparkles } from 'lucide-react'

import { cn } from 'lib/utils'

import { useAskMdt } from '../context/AskMdtProvider'

/**
 * "Ask MDT" in the header (MYD-621), beside Messages and after its pattern:
 * it reads only the small Ask MDT context, never the conversation, so the
 * header does not re-render while an answer streams.
 *
 * Renders nothing when Ask MDT is not offered to this user: the provider is
 * not mounted, so `useAskMdt()` is null.
 */
export function AskMdtTrigger({ className }: { className?: string }) {
	const askMdt = useAskMdt()
	if (!askMdt) return null

	const isOpen = askMdt.mode !== 'closed'
	const shortcut = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform) ? '⌘K' : 'Ctrl+K'

	return (
		<button
			type="button"
			onClick={askMdt.toggle}
			data-testid="ask-mdt-trigger"
			aria-label="Ask MDT"
			aria-expanded={isOpen}
			title={`Ask MDT (${shortcut})`}
			className={cn(
				'relative inline-flex h-9 w-9 items-center justify-center rounded-md transition-colors',
				'text-gray-500 hover:text-primary',
				'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2',
				isOpen && 'bg-gray-100 text-primary',
				className,
			)}
		>
			<Sparkles className="h-5 w-5" />
		</button>
	)
}

export default AskMdtTrigger
